export default __webpack_public_path__ + "static/media/waterfall-kissin.99244fe7.jpeg";